import Duck from 'extensible-duck';
import Immutable from 'immutable';
import requestsManagerAxios from '../../lib/requestsManagerAxios';
import handleServerError2 from '../../lib/functions/handleServerError2';
import { toast } from 'react-toastify';

export default new Duck({
  namespace: 'public',
  store: 'customContent',
  types: [
    'SET_IMAGE_IS_SAVING',
    'UPDATE_CUSTOM_CONTENTS',
    'UPDATE_CUSTOM_CONTENTS_PENDING',
    'UPDATE_CUSTOM_CONTENTS_REJECTED',
    'UPDATE_CUSTOM_CONTENTS_FULFILLED',
  ],
  initialState: Immutable.fromJS({
    $$customContents: {},
    isSaving: false,
    imageIsSaving: false,
  }),
  reducer: ($$state, { type, payload, _meta }, { types }) => {
    switch (type) {
      case types.SET_IMAGE_IS_SAVING:
        return $$state.merge({ imageIsSaving: payload });
      case types.UPDATE_CUSTOM_CONTENTS_PENDING:
        return $$state.merge({ isSaving: true });
      case types.UPDATE_CUSTOM_CONTENTS_REJECTED:
        handleServerError2(payload, {
          on422: () => {
            toast.error(
              "We're having problems saving this page. Please refresh and try again"
            );
          },
        });
        return $$state.merge({ isSaving: false, imageIsSaving: false });
      case types.UPDATE_CUSTOM_CONTENTS_FULFILLED:
        toast.success('Saved.', { autoClose: 2000 });
        return $$state.merge({
          isSaving: false,
          imageIsSaving: false,
          $$customContents: Immutable.fromJS(payload.data),
        });
      default:
        return $$state;
    }
  },
  selectors: {},
  creators: ({ types }) => ({
    updateCustomContents: (id, content) => ({
      type: types.UPDATE_CUSTOM_CONTENTS,
      payload: requestsManagerAxios.patch(`/admin/custom_contents/${id}`, {
        custom_content: { content },
      }),
    }),
    onSetImageIsSaving: bool => ({
      type: types.SET_IMAGE_IS_SAVING,
      payload: bool,
    }),
  }),
});
